/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Color_Role_SuccessInputs */

const en_enum_color_role_success = /** @type {(inputs: Enum_Color_Role_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Success`)
};

const de_enum_color_role_success = /** @type {(inputs: Enum_Color_Role_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Success`)
};

/**
* | output |
* | --- |
* | "Role Success" |
*
* @param {Enum_Color_Role_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_color_role_success = /** @type {((inputs?: Enum_Color_Role_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Color_Role_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_color_role_success(inputs)
	return de_enum_color_role_success(inputs)
});